<span matDialogTitle>{{ 'Salvataggio prospettiva' | siaTranslate }}</span>
<mat-dialog-content>
  <div class="dialog-content">
    @if (data.update) {
      <mat-form-field>
        <mat-label>{{ 'Livello prospettiva' | siaTranslate }}</mat-label>
        <mat-select [(value)]="originalType" [disabled]="true">
          @for (type of types; track $index) {
            <mat-option [value]="type.id">
              {{ type.description }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field>
      <mat-label>{{ 'Nuovo livello prospettiva' | siaTranslate }}</mat-label>
      <mat-select [(value)]="data.configuration.levelType">
        @for (type of types; track $index) {
          <mat-option [value]="type.id">
            {{ type.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="save()">Salva</button>
</mat-dialog-actions>
